import createIcon from '../../createIcon';

/**
 * @component @name Fullscreen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxNEg1VjE5SDEwVjE3SDdWMTRaTTUgMTBIN1Y3SDEwVjVINVYxMFpNMTcgMTdIMTRWMTlIMTlWMTRIMTdWMTdaTTE0IDVWN0gxN1YxMEgxOVY1SDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fullscreen = createIcon('Fullscreen', [
  [
    'path',
    {
      d: 'M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z',
      key: '1depyc',
    },
  ],
]);

export default Fullscreen;
